// extracted by mini-css-extract-plugin
export default {"option":"YesNoSelectOptions_option__T-ql-","icon":"YesNoSelectOptions_icon__9ZuX8"};